import LegalDocViewer from "@/components/LegalDocViewer";
import content from "@/legal-rendered/acceptable_use";

export default function AcceptableUsePage() {
  return (
    <LegalDocViewer
      title="Acceptable Use Policy"
      subtitle="Conduct rules for users, Experts and integrators"
      policyId="acceptable_use"
      policyVersion="1.1.0"
      content={content}
    />
  );
}
